"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var utils_1 = require("../utils");
var index_1 = require("./index");
exports.default = (function (_a) {
    var className = _a.className, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left, style = _a.style, iconStyle = _a.iconStyle, _b = _a.position, position = _b === void 0 ? "fixed" : _b, _c = _a.zIndex, zIndex = _c === void 0 ? 1 : _c, others = tslib_1.__rest(_a, ["className", "top", "right", "bottom", "left", "style", "iconStyle", "position", "zIndex"]);
    return (React.createElement(index_1.IconButton, tslib_1.__assign({}, others, { className: className, iconStyle: iconStyle, circle: true, blue: true, style: tslib_1.__assign({ top: utils_1.toREMString(top), right: utils_1.toREMString(right), bottom: utils_1.toREMString(bottom), left: utils_1.toREMString(left), zIndex: zIndex,
            position: position }, style) })));
});
